import { NotInitError } from './errors'
import type { Authentication, Permission } from './interfaces'
import type { ServiceType } from './types'

/**
 * 对方法进行假实现
 */
const dummyFunction: (...args: any[]) => never = () => {
  /** 直接抛出错误 */
  throw NotInitError
}

export class DummyAuth implements Authentication {
  serviceType: ServiceType = 'auth'

  getLoginUrl = dummyFunction

  parseLoginPayload = dummyFunction

  cleanLoginPayload = dummyFunction

  storeLoginPayload = dummyFunction

  handleLogin = dummyFunction

  validateToken = dummyFunction

  getUserInfo = dummyFunction

  refreshToken = dummyFunction

  queryUsers = dummyFunction

  queryChildDeptList = dummyFunction

  logout = dummyFunction

  isInternalRtokenValid = dummyFunction
}

export class DummyPerm implements Permission {
  serviceType: ServiceType = 'perm'

  getFunctionalPermissions = dummyFunction

  getMenuTree = dummyFunction

  getResourceList = dummyFunction

  getAllResourceCodeList = dummyFunction

  hasMenuPermission = dummyFunction

  getMenuList = dummyFunction

  filterRouteList = dummyFunction

  getFilteredRouteList = dummyFunction

  getRoleList = dummyFunction

  getBaseRoleList = dummyFunction

  hasRole = dummyFunction
}
